var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFloodFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 16.933 16.933",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3.3552,
    y: 2.7128,
    width: 10.305,
    height: 4.2137,
    fill: "#b3b3b3",
    stroke: "#4d4d4d",
    strokeWidth: 0.48684
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.3076 4.8856s-0.71971 0.14018-1.3182 0c-0.59846-0.14018-1.1876-3.1826 0-3.3931 1.1876-0.21053 11.126-0.29462 12.707 0 1.5816 0.29462 1.1861 6.0459-1.4236 6.4886-2.6097 0.44274-4.7395-0.78827-4.6927 1.3692 0.04682 2.1574 0 6.3696 0 6.3696",
    fill: "none",
    stroke: "#333",
    strokeLinejoin: "round",
    strokeWidth: 0.48684
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.8102,
    y: 9.476,
    width: 1.654,
    height: 6.2799,
    fill: "#b3b3b3",
    stroke: "#4d4d4d",
    strokeWidth: 0.23811
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloodFill);
export default __webpack_public_path__ + "static/media/FloodFill.818b42f7e9c61afc4099d7d544706fa4.svg";
export { ForwardRef as ReactComponent };